// src/components/web-booking/WeeklyClosureToggle.js
// 固定公休（每週）星期切換 — Plan 094 Phase 2
// 點選的星期即「每週自動公休」，不必逐日設定。值 = days_of_week（0=日..6=六）。
import React from 'react';
import { Box, Typography } from '@mui/material';

const WEEK = ['日', '一', '二', '三', '四', '五', '六'];

const WeeklyClosureToggle = ({ value = [], onToggle, busy }) => {
  const sorted = [...value].sort((a, b) => a - b);
  return (
    <Box>
      <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1.5 }}>
        點選每週公休的星期 → 之後那天<b>自動店休</b>，不必逐日設定。
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {WEEK.map((lbl, d) => {
          const on = value.includes(d);
          return (
            <Box
              key={d}
              onClick={() => !busy && onToggle(d)}
              sx={{
                width: 44, height: 44, borderRadius: 2,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: busy ? 'default' : 'pointer', userSelect: 'none',
                fontWeight: 700, fontSize: 14, transition: 'all 120ms', border: '1px solid',
                ...(on
                  ? { bgcolor: '#fff8e1', borderColor: '#e65100', color: '#e65100' }
                  : { bgcolor: '#fff', borderColor: '#e0e0e0', color: '#94a3b8' })
              }}
            >
              {lbl}
            </Box>
          );
        })}
      </Box>
      <Typography sx={{ fontSize: 12, color: sorted.length ? '#e65100' : '#999', mt: 1.5 }}>
        {sorted.length
          ? `每週 ${sorted.map((d) => '週' + WEEK[d]).join('、')} 自動公休（網路與電話一致）`
          : '尚未設定固定公休日。'}
      </Typography>
    </Box>
  );
};

export default WeeklyClosureToggle;
